import { Container } from './container';
import { ContainerBuilder } from './container-builder';

export class Kernel {
  private booted = false;
  private container?: Container;

  public constructor (private readonly debug = false) {
  }

  public getContainer (): Container {
    if (!this.container) {
      throw new Error('Cannot retrieve the container from a non-booted kernel.');
    }

    return this.container;
  }

  public boot (): void {
    if (this.booted) {
      return;
    }

    this.container = this.buildContainer();
    this.container.compile();
  }

  protected getKernelParameters (): Record<string, unknown> {
    return {
      'kernel.debug': this.debug,
    };
  }

  protected buildContainer (): ContainerBuilder {
    const container = this.getContainerBuilder();

    this.build(container);

    return container;
  }

  protected getContainerBuilder (): ContainerBuilder {
    const containerBuilder = new ContainerBuilder();

    containerBuilder.getParameterBag().add(this.getKernelParameters());

    return containerBuilder;
  }

  protected build (containerBuilder: ContainerBuilder): void {
    // override this method to configure the container
  }
}
